import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MfaSetupPageRoutingModule } from './mfa-setup-page-routing.module';
import { MfaSetupPage } from './mfa-setup.page';
import { IonIntlTelInputModule } from 'src/app/shared/libs/ion-intl-tel-input/ion-intl-tel-input.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    MfaSetupPageRoutingModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    IonIntlTelInputModule
  ],
  providers: [],
  declarations: [MfaSetupPage]
})
export class MfaSetupPageModule { }
